import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { t } from '../utils/translations';
import { ClipboardList, Truck, CheckCircle } from 'lucide-react';
export function HowItWorks() {
  const {
    lang
  } = useLanguage();
  const text = t[lang].howItWorks;
  const containerRef = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start center', 'end center']
  });
  const lineWidth = useTransform(scrollYProgress, [0, 0.8], ['0%', '100%']);
  const steps = [{
    num: 1,
    icon: <ClipboardList size={36} data-id="element-352" />,
    title: text.step1.title,
    desc: text.step1.desc
  }, {
    num: 2,
    icon: <Truck size={36} data-id="element-353" />,
    title: text.step2.title,
    desc: text.step2.desc
  }, {
    num: 3,
    icon: <CheckCircle size={36} data-id="element-354" />,
    title: text.step3.title,
    desc: text.step3.desc
  }];
  return <section className="py-24 bg-white relative overflow-hidden" ref={containerRef} data-id="element-355">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-356">
        <div className="text-center mb-20" data-id="element-357">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 100,
          damping: 15
        }} className="text-4xl md:text-6xl font-condensed font-black text-mf-black uppercase tracking-tight mb-6" data-id="element-358">
            {text.title}
          </motion.h2>
          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: 96
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="h-1.5 bg-mf-red mx-auto rounded-full" data-id="element-359"></motion.div>
        </div>

        <div className="relative" data-id="element-360">
          {/* Animated Connecting Line (Desktop only) */}
          <div className="hidden md:block absolute top-16 left-[15%] right-[15%] h-1 bg-gray-100 rounded-full z-0 overflow-hidden" data-id="element-361">
            <motion.div className="h-full bg-mf-red" style={{
            width: lineWidth
          }} data-id="element-362" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-363">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            delay: index * 0.2,
            type: 'spring',
            stiffness: 100,
            damping: 15
          }} className="flex flex-col items-center text-center group" data-id="element-364">
                <div className="relative mb-8" data-id="element-365">
                  <div className="w-32 h-32 bg-white border-4 border-gray-100 group-hover:border-mf-red rounded-3xl flex items-center justify-center text-gray-400 group-hover:text-mf-red shadow-lg group-hover:shadow-2xl transition-all duration-500 transform group-hover:-translate-y-2 rotate-3 group-hover:rotate-0" data-id="element-366">
                    {step.icon}
                  </div>
                  <div className="absolute -top-4 -right-4 w-12 h-12 bg-mf-black text-white font-black text-xl rounded-2xl flex items-center justify-center border-4 border-white shadow-md transform -rotate-6 group-hover:rotate-12 transition-transform duration-500" data-id="element-367">
                    {step.num}
                  </div>
                </div>
                <h3 className="text-2xl md:text-3xl font-condensed font-black uppercase mb-4 text-mf-black" data-id="element-368">
                  {step.title}
                </h3>
                <p className="text-gray-600 font-medium text-lg max-w-xs leading-relaxed" data-id="element-369">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}